import http from '../http'

/** 当前后台账号的个人日程接口，不允许由页面指定归属身份。 */
export const fetchPersonalCalendarRange = (payload) => http.post('/system/personal-calendar/range', payload)

export const savePersonalCalendar = (payload) => http.post('/system/personal-calendar/save', payload)

export const deletePersonalCalendar = (id) => http.post('/system/personal-calendar/delete', {id})
